import service from '@/store/services/users-service';

const state = {
    role: {},
    list: {},
    user: {},
    meta: {},
    usersList: {},
    retouchersList: {},
    updateUser: {},
    delUser: {},
    restoreUser: {},
    createUser: {},
    chosenRolesUsersList: {},
    weekBonusData: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
     SET_USERS_LIST: (state, usersList) => {
        state.usersList = usersList;
    },
     SET_RETOUCHERS_LIST: (state, retouchersList) => {
        state.retouchersList = retouchersList;
    },
     SET_UPDATE_USER: (state, updateUser) => {
        state.updateUser = updateUser;
    },
    SET_DELETE_USER: (state, delUser) => {
        state.delUser = delUser;
    },
    SET_RESTORE_USER: (state, restoreUser) => {
        state.restoreUser = restoreUser;
    },
    SET_CREATE_USER: (state, createUser) => {
        state.createUser = createUser;
    },
    SET_RESOURCE_ROLE: (state, role) => {
        state.role = role;
    },
    SET_CHOSEN_ROLE_RETOUCHERS_LIST: (state, chosenRolesUsersList) => {
        state.chosenRolesUsersList = chosenRolesUsersList;
    },
    SET_RESOURCE: (state, user) => {
        state.user = user;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_WEEK_BONUS_DATA: (state, weekBonusData) => {
        state.weekBonusData = weekBonusData;
    }
};

const actions = {
    list({commit, dispatch}, params) {
        return service.list(params)
            .then(({list, meta}) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
    usersList({commit, dispatch}, params) {
        return service.usersList(params)
            .then(({usersList}) => {
                commit('SET_USERS_LIST', usersList);
            });
    },
    chosenRolesUsersList({commit, dispatch}, params) {
        return service.chosenRolesUsersList(params)
            .then(({chosenRolesUsersList}) => {
                commit('SET_CHOSEN_ROLE_RETOUCHERS_LIST', chosenRolesUsersList);
            });
    },
    retouchersList({commit, dispatch}, params) {
        return service.retouchersList(params)
            .then(({retouchersList}) => {
                commit('SET_RETOUCHERS_LIST', retouchersList);
            });
    },

    get({commit, dispatch}, params) {
        return service.get(params)
            .then((user) => {
                commit('SET_RESOURCE', user);
            }).then((role) => {
                commit('SET_RESOURCE_ROLE', role);
            });
    },

    add({commit, dispatch}, params) {
        return service.add(params)
            .then((user) => {
                commit('SET_RESOURCE', user);
            });
    },

    update({commit, dispatch}, params) {
        return service.update(params)
            .then((user) => {
                commit('SET_RESOURCE', user);
            });
    },
    updateUser({commit, dispatch}, params) {
        return service.updateUser(params)
            .then((updateUser) => {
                commit('SET_UPDATE_USER', updateUser);
            });
    },
    delUser({commit, dispatch}, params) {
        return service.delUser(params)
            .then((delUser) => {
                commit('SET_DELETE_USER', delUser);
            });
    },
    restoreUser({commit, dispatch}, params) {
        return service.restoreUser(params)
            .then((restoreUser) => {
                commit('SET_RESTORE_USER', restoreUser);
            });
    },
    createUser({commit, dispatch}, params) {
        return service.createUser(params)
            .then((createUser) => {
                commit('SET_CREATE_USER', createUser);
            });
    },

    destroy({commit, dispatch}, params) {
        return service.destroy(params);
    },
    getWeekBonusData({commit, dispatch}, params){
        return service.getWeekBonusData(params)
            .then((weekBonusData) => {
                commit('SET_WEEK_BONUS_DATA', weekBonusData);
            });
    }
};

const getters = {
    role: state => state.role,
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    user: state => state.user,
    usersList: state => state.usersList,
    retouchersList: state => state.retouchersList,
    updateUser: state => state.updateUser,
    delUser: state => state.delUser,
    restoreUser: state => state.restoreUser,
    createUser: state => state.createUser,
    chosenRolesUsersList: state => state.chosenRolesUsersList,
    weekBonusData: state => state.weekBonusData,
};

const users = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default users;
